import { render } from "./HistorialCompletoDM.vue?vue&type=template&id=3b2a4092&scoped=true"
import script from "./HistorialCompletoDM.vue?vue&type=script&lang=js"
export * from "./HistorialCompletoDM.vue?vue&type=script&lang=js"

import "./HistorialCompletoDM.vue?vue&type=style&index=0&id=3b2a4092&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2a4092"]])

export default __exports__